<ui-dialog
    size="small"
    [open]="isIndeedDisconnectModalOpen"
    header="{{ 'settings.integration.disconnectIndeedDialogHeader' | appTranslate }}"
    (closing)="isIndeedDisconnectModalOpen = false"
>
    <p>{{ 'settings.integration.disconnectIndeedDialogConfirmMessage' | appTranslate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="isIndeedDisconnectModalOpen = false">
            {{ 'settings.integration.disconnectIndeedDialogCancelButton' | appTranslate }}
        </ui-button>
        <ui-button type="danger" (click)="onDisconnectIndeed()">
            {{ 'settings.integration.disconnectIndeedDialogDisconnectButton' | appTranslate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isIndeedIntegrationModalOpen"
    header="{{ 'settings.integration.connectIndeedDialogHeader' | appTranslate }}"
    (closing)="closeModal(activeIntegrations.indeed)"
>
    <p>{{ 'settings.integration.connectIndeedDialogMessage' | appTranslate }}</p>
    <div class="flex justify-center align-items-center width-full">
        <a [href]="indeedOAuthUrl">
            <img
                src="assets/logos/login-with-indeed.png"
                alt="{{ 'settings.integration.connectIndeedDialogLoginButtonAlt' | appTranslate }}"
                class="indeed-login-button width-full"
            />
        </a>
    </div>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeModal(activeIntegrations.indeed)">{{
            'cancel' | appTranslate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isWorkableModalOpen"
    header="{{ 'settings.integration.manageWorkableDialogHeader' | appTranslate }}"
    (closing)="closeModal(activeIntegrations.workable)"
>
    <app-settings-workable-form #workableForm></app-settings-workable-form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeModal(activeIntegrations.workable)">
            {{ 'settings.integration.manageWorkableDialogCancelButton' | appTranslate }}
        </ui-button>
        <ui-button type="primary" (click)="onCreate(workableForm, workableForm.model, activeIntegrations.workable)">
            {{ 'settings.integration.manageWorkableDialogSaveButton' | appTranslate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isGreenhouseModalOpen"
    header="{{ 'settings.integration.manageGreenhouseDialogHeader' | appTranslate }}"
    (closing)="closeModal(activeIntegrations.greenhouse)"
>
    <app-settings-greenhouse-form #greenhouseForm></app-settings-greenhouse-form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeModal(activeIntegrations.greenhouse)">
            {{ 'settings.integration.manageGreenhouseDialogCancelButton' | appTranslate }}
        </ui-button>
        <ui-button
            type="primary"
            (click)="onCreate(greenhouseForm, greenhouseForm.model, activeIntegrations.greenhouse)"
        >
            {{ 'settings.integration.manageGreenhouseDialogSaveButton' | appTranslate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isXeroModalOpen"
    header="{{ 'settings.integration.connectXeroDialogHeader' | appTranslate }}"
    (closing)="closeModal(activeIntegrations.xero)"
>
    <p>{{ 'settings.integration.connectXeroDialogMessage' | appTranslate }}</p>

    <div class="flex justify-center align-items-center width-full">
        <a [href]="xeroOAuthUrl">
            <img
                src="assets/logos/connect-xero.svg"
                alt="{{ 'settings.integration.connectXeroButtonAlt' | appTranslate }}"
                class="xero-login-button width-full"
            />
        </a>
    </div>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeModal(activeIntegrations.xero)">
            {{ 'settings.integration.connectXeroDialogCancelButton' | appTranslate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isXeroDisconnectModalOpen"
    header="{{ 'settings.integration.disconnectXeroDialogHeader' | appTranslate }}"
    (closing)="isXeroDisconnectModalOpen = false"
>
    <p>{{ 'settings.integration.disconnectXeroDialogMessage' | appTranslate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="isXeroDisconnectModalOpen = false">
            {{ 'settings.integration.disconnectXeroDialogCancelButton' | appTranslate }}
        </ui-button>
        <ui-button type="danger" (click)="onDisconnectXero()">
            {{ 'settings.integration.disconnectXeroDialogDisconnectButton' | appTranslate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isZapierModalOpen"
    header="{{ 'settings.integration.connectZapierDialogHeader' | appTranslate }}"
    (closing)="closeModal(activeIntegrations.zapier)"
>
    <p>{{ 'settings.integration.connectZapierDialogMessage' | appTranslate }}</p>
    <app-copy-input value="{{ zapierApiKey }}" readOnly="true"></app-copy-input>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeModal(activeIntegrations.zapier)">
            {{ 'settings.integration.connectZapierDialogCancelButton' | appTranslate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isLinkedinModalOpen"
    [header]="'settings.integration.manageLinkedinDialogHeader'"
    (closing)="closeModal(activeIntegrations.linkedin)"
>
    <app-settings-linkedin-form (canSubmit)="canSubmitLinkedin = $event" #linkedinForm></app-settings-linkedin-form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeModal(activeIntegrations.linkedin)">
            {{ 'cancel' | translate }}
        </ui-button>
        <ui-button
            type="primary"
            [disabled]="!canSubmitLinkedin"
            (click)="onCreate(linkedinForm, linkedinForm.model, activeIntegrations.linkedin)"
        >
            {{ 'save' | translate }}
        </ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{ 'settings.integration.header' | appTranslate }}"
        [menuService]="settingsMenuService"
    ></app-header>
    <ui-banner variant="danger" class="margin-bottom-3" *ngIf="indeedEmailVerificationRequiredError">
        {{ 'settings.integration.indeedEmailVerificationRequiredMessage' | appTranslate }}
    </ui-banner>

    <div class="card-grid" role="list">
        <app-integration-card
            *ngFor="let integrationType of integrationTypes | keyvalue"
            class="columns-3 margin-bottom-3"
            [shouldUseSVGLogo]="true"
            [connectionState]="integrationTypeInUse(integrationType.value)"
            [primaryAction]="
                integrationTypeInUse(integrationType.value) === 'disconnected' ? { action: 'CONNECT' } : undefined
            "
            [integrationType]="integrationType.value"
            [disabled]="integrationType.value.disabled"
            [availableActions]="getAvailableActions(integrationType.value)"
            (onAction)="onIntegrationEvent($event, integrationType.value)"
            role="listitem"
        >
            <div
                class="description"
                *ngIf="
                    integrationType.key === activeIntegrations.xero &&
                    integrationTypeInUse(integrationType.value) !== 'disconnected'
                "
            >
                {{ xeroCompanyName }}
            </div>
        </app-integration-card>
    </div>
</div>
